<template>
    <layout-two-column>
        <template #column>
            <div class="d-flex flex-column gap-4">
                <panel v-if="enabledApprovalEmails">
                    <approvals-manager/>
                </panel>

                <panel>
                    <orders-history/>
                </panel>

                <panel v-if="permissions.support">
                    <orders-question/>
                </panel>
            </div>
        </template>

        <template #default>
            <loading v-if="loading"/>
            <div v-else>
                <!-- Home page partner message -->
                <home-message/>

                <views-home-type-products v-if="type === types.products && null !== groupingType"
                                          :grouping="groupingType"
                                          :categories="categories"
                                          :catalog-messages="catalogMessages"/>

                <views-home-type-categories v-if="type === types.categories && null !== groupingType"
                                            :grouping="groupingType"
                                            :categories="categories"
                                            :catalog-messages="catalogMessages"/>

                <products-list v-if="products"
                               class="mt-3"
                               :value="products.items"
                               :grouping="groupingType"
                               :grouping-id="products.groupingId"/>
            </div>
        </template>
    </layout-two-column>
</template>

<script>

    import {mapGetters} from "vuex";

    import mixin_view from "@/mixins/view";
    import mixin_catalog from "@/mixins/catalog";
    import mixin_widget from "@mixins_widget";
    import emitter from "@/api/events";
    import {CATALOG_STATUS_MESSAGE, CATALOG_ROOT_CATEGORY, HOME_PAGE_GROUPING_TYPE} from "@/constants";

    import AdvisorRecommendations from "@/components/advisor/AdvisorRecommendations";
    import ApprovalsManager from "@/components/approvals/ApprovalsManager.vue";
    import HomeMessage from "@components_home_HomeMessage";
    import LayoutTwoColumn from "@/components/layout/LayoutTwoColumn";
    import Loading from "@/components/Loading";
    import OrdersHistory from "@/components/orders/OrdersHistory";
    import OrdersQuestion from "@/components/orders/OrdersQuestion";
    import Panel from "@/components/Panel";
    import ProductsList from "@/components/products/ProductsList";
    import ViewsHomeTypeCategories from "@/views/home/ViewsHomeTypeCategories";
    import ViewsHomeTypeProducts from "@/views/home/ViewsHomeTypeProducts";

    export default {
        name: "ViewsHome",
        mixins: [mixin_view, mixin_catalog, mixin_widget],
        components: {
            ApprovalsManager,
            AdvisorRecommendations,
            HomeMessage,
            LayoutTwoColumn,
            Loading,
            OrdersHistory,
            OrdersQuestion,
            Panel,
            ProductsList,
            ViewsHomeTypeCategories,
            ViewsHomeTypeProducts
        },
        data() {

            return {
                t_path: "views.home",
                loading: false,
                types: {
                    products: "products",
                    categories: "categories"
                },
                type: process.env.VUE_APP_HOME_PAGE_TYPE,
                products: null,
                catalogMessageSources: []
            }
        },
        computed: {
            ...mapGetters({
                groupingType: "grouping/type"
            }),
            enabledApprovalEmails() {

                return 1 == process.env.VUE_APP_ENABLED_APPROVAL_DISPLAY_USER_MANAGER && this.$store.getters['user/approvalManagerEmail']
            },
            categories() {

                return this.catalog_getCategories();
            },
            permissions() {

                return {
                    support: null === this.$store.getters["user/impersonatorToken"]
                };
            },
            catalogMessages() {

                if (CATALOG_STATUS_MESSAGE && 0 < this.catalogMessageSources.length) {

                    return this.catalogMessageSources.map(
                        ({message, email}) => this.$t(`catalog.message.${message}`, {
                            equipmentQuizLink: this.$router.resolve({name: "quiz", query: {reset: true}}).fullPath,
                            widgetOptions: this.widget_optionsJson,
                            supportEmail: email
                        })
                    )
                }

                return 0 === this.categories.length && (!this.products || 0 === this.products.items.length)
                    ? [this.t("noAvailableItems", {widgetOptions: this.widget_optionsJson})]
                    : []
            }
        },
        methods: {
            fetch() {

                this.loading = true;

                const promises = [this.catalog_fetchCategories({type: HOME_PAGE_GROUPING_TYPE})];

                if (CATALOG_STATUS_MESSAGE) {

                    promises.push(this.$store.dispatch("user/catalog/getCatalogMessages"))
                }

                return Promise
                    .all(promises)
                    .then((results) => {

                        const [catalog, catalogMessages] = results;
                        this.catalogMessageSources = undefined !== catalogMessages ? catalogMessages : []

                        this.catalog_logActivity();

                        if (true === CATALOG_ROOT_CATEGORY) {

                            return this.$platform
                                .get(`/api/v2/grouping/${this.groupingType}/${this.$store.getters["grouping/rootItem"].id}?hiearchy_search=false`)
                                .then(response => {

                                    this.products = {
                                        groupingId: response.data.results._id,
                                        items: response.data.results.products
                                    };
                                });
                        }
                    })
                    .finally(() => this.loading = false);
            },
            refreshProducts() {

                if (this.products) {

                    this.$platform
                        .get(`/api/v2/grouping/${this.groupingType}/${this.products.groupingId}?hiearchy_search=false`)
                        .then(response => this.products.items = response.data.results.products);
                }
            }
        },
        mounted() {

            this.fetch();

            emitter.on('user_constraints_fetch', this.refreshProducts);
        },
        beforeUnmount() {

            emitter.off('user_constraints_fetch', this.refreshProducts);
        }
    }
</script>